import { type QueryClient } from "@tanstack/react-query";
import {
  type LinkProps,
  Outlet,
  createRootRouteWithContext,
} from "@tanstack/react-router";
import { type i18n } from "i18next";
import React from "react";

import { fetchTenantQueryOptions } from "@/user/services/tenant";

import NotificationContainer from "./components/layouts/notification/NotificationContainer";
import { type Optional, type Tenant, type User } from "./types";

const UpdatePwa = React.lazy(() => import("./layouts/UpdatePwa"));

export interface RouterContext {
  queryClient: QueryClient;
  t: i18n["t"];
  title?: () => string;
  crumb?: Array<
    | {
        Icon: React.ComponentType<{ className?: string }>;
        label?: never;
        link?: LinkProps;
      }
    | {
        Icon?: never;
        label: string;
        link?: LinkProps;
      }
  >;
  hideMenu?: boolean;
  hideHeader?: boolean;
  hideCrumb?: boolean;
  hideWidgets?: boolean;
  compactMenu?: boolean;
  user?: User<true, true>;
  tenant: Tenant;
}

export type ChildRouteContext = Optional<
  RouterContext,
  "queryClient" | "t" | "tenant"
>;

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: async ({ context }) => {
    const tenant = await context.queryClient.ensureQueryData(
      fetchTenantQueryOptions(),
    );
    return {
      tenant,
    } satisfies ChildRouteContext;
  },
  component: Component,
});

function Component() {
  return (
    <>
      <div className="flex flex-col">
        <Outlet />
      </div>
      <UpdatePwa />
      <NotificationContainer />
      {/* <ReactQueryDevtools buttonPosition="top-right" />
      <TanStackRouterDevtools position="bottom-right" /> */}
    </>
  );
}
